module.exports = __webpack_public_path__ + "static/media/men_kit.31785832.png";